import {useCallback, useEffect, useState} from "react";
import {EmblaCarouselType} from "embla-carousel";

type EmblaNavigationType = {
    prevBtnDisabled: boolean;
    nextBtnDisabled: boolean;
    onPrevButtonClick: () => void;
    onNextButtonClick: () => void;
}

export const useEmblaNavigation = (emblaApi: EmblaCarouselType | undefined): EmblaNavigationType => {
    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

    const onPrevButtonClick = useCallback(
        () => emblaApi?.scrollPrev(),
        [emblaApi],
    );

    const onNextButtonClick = useCallback(
        () => emblaApi?.scrollNext(),
        [emblaApi],
    );

    const updateButtons = useCallback((api: EmblaCarouselType) => {
        setPrevBtnDisabled(!api.canScrollPrev());
        setNextBtnDisabled(!api.canScrollNext());
    }, []);

    useEffect(() => {
        if (!emblaApi) return;

        updateButtons(emblaApi);

        emblaApi.on('reInit', updateButtons);
        emblaApi.on('select', updateButtons);

        return () => {
            emblaApi.off('reInit', updateButtons);
            emblaApi.off('select', updateButtons);
        };
    }, [emblaApi, updateButtons]);

    return {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick,
    };
}
